import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'text/plain',
    'Accept': 'application/json',
    'Access-Control-Allow-Origin': '*'
  })
};

@Injectable()
export class PowerBIAuthenticationService {
  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') private originUrl: string
  ) { }

  getReportConfiguration(groupId: string, reportId: string, datasetId: string) {
    return this.http.get(this.originUrl + 'api/PowerBI/' + groupId + '/Report/' + reportId + '/Dataset/' + datasetId, httpOptions);
  }
}
